import { render, staticRenderFns } from "./Onepage-AW.vue?vue&type=template&id=74d2de24&scoped=true"
import script from "./Onepage-AW.vue?vue&type=script&lang=js"
export * from "./Onepage-AW.vue?vue&type=script&lang=js"
import style0 from "./Onepage-AW.vue?vue&type=style&index=0&id=74d2de24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d2de24",
  null
  
)

export default component.exports